import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sticky-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_10 = { key: 0 }


import { defineComponent, defineProps, onBeforeMount, onMounted, computed } from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { differenceInYears, differenceInMonths, differenceInDays } from "date-fns";

const store = useStore()

const notyf = new Notyf()
const considerInsurance = computed(() => process.env.VUE_APP_CONSIDER_INSURANCE === "true");

const __default__ = defineComponent({
  name: "CustDataPetTableRow",
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: ['petData', 'language'],
  setup(__props) {


const props = __props

const store = useStore()
var ageYears: number;
var ageMonths: number;
var ageDays: number;

function editingPet(): boolean {
  console.log(store.getters.getEditedCustEditingPet)
  return (store.getters.getEditedCustEditingPet)
}

function showingPetRecord(): boolean {
  console.log(store.getters.getShowingPetRecord)
  return (store.getters.getShowingPetRecord)
}

function editingCustomer(): boolean {
  console.log(store.getters.getEditingCustomer)
  return (store.getters.getEditingCustomer)
}

function iniEditing(editingPetData: any) {
  console.log("iniEditing")
  console.log(store.getters.getEditedCustEditingPet)
  console.log(store.getters.getEditedCustNewPetData)
  store.dispatch('iniEditedCustPetEditing', editingPetData)
  store.dispatch('toggleEditedCustPetEditing', false)
  console.log(store.getters.getEditedCustNewPetData)
  console.log(store.getters.getEditedCustEditingPet)
}

async function iniRecord(showRecordPetData: any) {
  console.log("iniRecord")
  console.log(store.getters.getShowingPetRecord)
  console.log(showRecordPetData)
  if(showRecordPetData.pet_id != 0)
  {
    await store.dispatch('iniPetRecord', {editingPetData: showRecordPetData, language : props.language})
    console.log("back to iniRecord")
    console.log(store.getters.getPetRecord)
    store.dispatch('toggleShowingPetRecord', false)
  }
  else
  {
    console.log("Error: Pet ID is 0")
  }
}


const remove = async (petData: any, $t: any) => {
  if (confirm($t && $t('PetData.ConfirmDelete'))) {
    //TODO:Create notification to ask if it is really to delete
    console.log("remove")
    console.log(store.getters.getEditedCustomerPets)
    if (petData.pet_id != 0) {
      // Store pet to be deleted in the DB when saving data.
      // Only of it hasn't been added in this interaction
      await store.dispatch('savePetToBeDeleted', petData.pet_id)
    }
    try {
      // Remove pet from the list front end
      await store.dispatch('removePetEditedCustomer', petData.pet_pos)
      console.log(store.getters.getEditedCustomerPets)
      notyf.success($t('PetData.NotyfPetRemoved'))
    } catch (e) {
      notyf.error($t('PetData.NotyfErrorRemovePet'))
    }
  }
}

onBeforeMount(() => {
  console.log(props.petData.birth)
  const birthDate = new Date(props.petData.birth);
  console.log(birthDate)
  ageYears = differenceInYears(new Date(), birthDate);
  console.log(ageYears)
  ageMonths = differenceInMonths(new Date(), birthDate) - 12 * ageYears;
  console.log(ageMonths)
  ageDays = differenceInDays(new Date(), birthDate);
  console.log(ageDays);

})

onMounted(() => {
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.owner), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.species), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.breed), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.gender), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.birth), 1)
    ]),
    _createElementVNode("td", null, [
      (_unref(ageYears) == 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(ageYears)) + " " + _toDisplayString(_ctx.$t('General.Year')), 1))
        : _createCommentVNode("", true),
      (_unref(ageYears) > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(ageYears)) + " " + _toDisplayString(_ctx.$t('General.Years')), 1))
        : _createCommentVNode("", true),
      (_unref(ageMonths) == 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(ageMonths)) + " " + _toDisplayString(_ctx.$t('General.Month')), 1))
        : _createCommentVNode("", true),
      (_unref(ageMonths) > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(ageMonths)) + " " + _toDisplayString(_ctx.$t('General.Months')), 1))
        : _createCommentVNode("", true),
      ((_unref(ageYears) == 0 && _unref(ageMonths) == 0 && _unref(ageDays) == 1))
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(ageDays)) + " " + _toDisplayString(_ctx.$t('General.Day')), 1))
        : _createCommentVNode("", true),
      ((_unref(ageYears) == 0 && _unref(ageMonths) == 0 && _unref(ageDays) > 1))
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(ageDays)) + " " + _toDisplayString(_ctx.$t('General.Days')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.fertile_status), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.petData.weight), 1)
    ]),
    (considerInsurance.value)
      ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
          _createElementVNode("div", null, _toDisplayString(__props.petData.policy), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          (!editingPet() && editingCustomer() && !showingPetRecord())
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "button is-warning is-small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (iniEditing(__props.petData)))
              }, _toDisplayString(_ctx.$t('General.Edit')), 1))
            : _createCommentVNode("", true)
        ]),
        (!editingCustomer() && !showingPetRecord())
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                class: "button is-danger is-small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (iniRecord(__props.petData)))
              }, _toDisplayString(_ctx.$t('General.Record')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})